import { resolveDashboardPermissionChangedBodyKey } from "@frontend-shared/utils";
import { ShieldHalf } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";
import type { IDashboardPermissionChangedCardProps } from "./types";

const DashboardPermissionChangedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewDashboard,
}: IDashboardPermissionChangedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewDashboard = useCallback(
    (): void =>
      onViewDashboard({
        dashboardUuid: data.dashboardUuid,
        projectUuid: data.projectUuid,
      }),
    [onViewDashboard, data.dashboardUuid, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="dashboard_permission_changed"
      createdAt={createdAt}
      isRead={isRead}
      icon={<ShieldHalf className="h-5 w-5 text-sky-500" />}
      iconBgClassName="bg-sky-500/10"
      ctaLabel={t("view_dashboard")}
      onCtaClick={handleViewDashboard}
      body={t(resolveDashboardPermissionChangedBodyKey(data.permissionLevel), {
        ownerName: data.ownerName,
        dashboardName: data.dashboardName,
      })}
    />
  );
};

export const DashboardPermissionChangedCard = memo(
  DashboardPermissionChangedCardComponent,
);
